module.exports = __webpack_public_path__ + "img/p6@2x.c21c48c2.png";